interface Props {
  value: boolean | null;
  onChange: (v: boolean) => void;
  label: string;
  required?: boolean;
}

export function YesNoToggle({ value, onChange, label, required }: Props) {
  return (
    <div>
      <div className="flex items-center gap-1.5 mb-2">
        <span className="text-sm font-medium">{label}</span>
        {required && <span className="text-destructive text-xs font-bold">*</span>}
      </div>
      <div className="grid grid-cols-2 gap-2">
        <button
          type="button"
          onClick={() => onChange(true)}
          className={`py-3.5 rounded-xl text-sm font-semibold transition-all active:scale-[0.97] border-2 ${
            value === true
              ? "bg-success/10 border-success/40 text-success"
              : "bg-card border-border text-muted-foreground hover:border-muted-foreground/30"
          }`}
        >
          Yes
        </button>
        <button
          type="button"
          onClick={() => onChange(false)}
          className={`py-3.5 rounded-xl text-sm font-semibold transition-all active:scale-[0.97] border-2 ${
            value === false
              ? "bg-destructive/10 border-destructive/40 text-destructive"
              : "bg-card border-border text-muted-foreground hover:border-muted-foreground/30"
          }`}
        >
          No
        </button>
      </div>
    </div>
  );
}
